import React, {Component, Fragment} from 'react';
import './ConnectionRequestsDashboard.css';
import { inject, observer } from 'mobx-react';
import SubHeader from './SubHeader';

import './ConnectionRequestsDashboard.css';
import ConnectionsTable from './ConnectionRequestTable';
import AddConnectionRequest from "./AddConnectionRequest";
import NewConnectionRequest from './NewConnectionRequest';
import CheckoutPopup from "./CheckoutPopup";

@inject('commonStore', 'connectionRequestsStore', 'subscriptionsStore')
@observer
export default class ConnectionRequestsDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleAddConnectionRequest: true,
      visibleCheckout: false
    }
  }

  componentDidMount = () => {
    this.props.connectionRequestsStore.loadConnectionRequests();
    this.props.subscriptionsStore.load();
  };

  changeAddConnectionRequestVisibility = () => {
    this.setState(prevState => ({visibleAddConnectionRequest : !prevState.visibleAddConnectionRequest }))
  }

  render() {
    const { connectionRequestsStore } = this.props;
    return (
      <div className={`ConnectionRequestsDashboard ${this.props.commonStore.loading || this.props.connectionRequestsStore.isLoading? 'loading' : ''}`}>
        <SubHeader onCheckout={() => this.setState({visibleCheckout: true})} />
        {this.props.commonStore.loading === false && (
          <Fragment>
            <ConnectionsTable
              connectionRequests={connectionRequestsStore.filteredGroupedByPlate}
            />
            <AddConnectionRequest visible={this.state.visibleAddConnectionRequest} onAddConnection={this.changeAddConnectionRequestVisibility}/>
            {!this.state.visibleAddConnectionRequest && <NewConnectionRequest onDone={this.changeAddConnectionRequestVisibility} onCancel={this.changeAddConnectionRequestVisibility} />}
            <CheckoutPopup visible={this.state.visibleCheckout} onCancel={() => this.setState({visibleCheckout: false})} />
          </Fragment>
        )}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/ConnectionRequestsDashboard.js